import { useAuth0 } from "@auth0/auth0-react";
import { Nav } from "react-bootstrap";
import logo from '../images/devaltuslogo1.png';

function Header() {
    const { logout, loginWithRedirect, isAuthenticated } = useAuth0();
    return (
        <>
            <div className='header'>
                <div >
                    <img src={logo} height={50} alt='' />
                </div>
                <div>
                    <Nav >
                        {isAuthenticated ?
                            <Nav.Link className="menuItem" onClick={() => logout({ logoutParams: { returnTo: "https://www.devaltus.com/" } })}>Log out </Nav.Link>
                            // <Nav.Link className="menuItem" onClick={() => logout({ logoutParams: { returnTo: "http://localhost:3000/" } })}>Log out</Nav.Link>
                            :
                            <Nav.Link className="menuItem" onClick={() => loginWithRedirect()}>Log in</Nav.Link>
                        }
                    </Nav>
                </div>
            </div>
        </>
    );
}

export default Header;